// 七牛云域名
const upload_url = 'https://up-z0.qiniup.com/';

//定义全局变量
// const url = 'http://b2c.api.xiaocx.cc';          // 测试环境
const url = 'https://food-yun.xiaocx.org';          // 生产环境
// const url = 'http://food-yun.xiaocx.cc';          // 测试环境
// const url = 'http://food-yun.xiaocx.my';            // 测试环境

let xcx = {
    title: '小程序（北京）科技有限公司',
    tel: '18612534550',
    mobile: '18612534550',
    email: 'hc.ji@xiaocx.work',
    address: '北京市海淀区优胜大厦D座15层1512',
    copyright: '2016-2026',
    icp: '京ICP备17004176',
    username: '纪海川',
    wechat_jhc: 'xiaocx-jhc',
    subject_type: null,// 主体类型
    businessId: null, // 业务单id
};
// 模块
const wxApi_url = url + '/mini';                // 小程序 - 前端模式
const api_url = url + '/seller';                // 商户 - 餐饮模块
const b2c_api_url = url + '/btoc';              // 商户 - 商城模块
const index_api_url = url + '/index';           // 前台模块
const ticket_url = url + '/cx';
const upload_img = url + '/mch';

const token = '';
const user_name = '';
const user_id = 0;
export default {
	upload_url,
	api_url,
	token,
	user_name,
	user_id,
	ticket_url,
	wxApi_url,
	upload_img,
	b2c_api_url,
    index_api_url,
    xcx
}



// WEBPACK FOOTER //
// ./src/util/common.js